import { Tabs } from 'antd'
import React, { useEffect } from 'react'
import clsx from 'clsx'

import Overview from './Overview'
import SaleChannelListing from './SaleChannelListing'
import StoreListing from './StoreListing'
import { useHistory } from 'react-router-dom'
import queryString from 'query-string'
import { useStoreActions } from 'easy-peasy'

const TABS = [
  { value: 'overview', label: 'Overview', component: Overview },
  // { value: 'sale_channel_listing', label: 'Sale Channel Listing', component: SaleChannelListing },
  { value: 'store_listing', label: 'Store Listing', component: StoreListing },
]
const SaleAnalytics = () => {
  const history = useHistory()
  const queryObject = queryString.parse(history.location.search)
  const { setBreadCrumb } = useStoreActions((actions: any) => actions.breadcrumb)

  const onTabClick = (tab: string) => {
    history.push({ search: queryString.stringify({ ...queryObject, tab }) })
  }

  useEffect(() => {
    setBreadCrumb([{ title: 'Sale Channel', path: '/analytics/sale-channel' }])
  }, [setBreadCrumb])
  return (
    <div className="px-8 py-7 w-full">
      <span className="text-3xl font-semibold">Sale Channel</span>
      <div className="mt-8 w-full">
        <Tabs
          destroyInactiveTabPane
          activeKey={
            !TABS.some((tab) => tab.value === queryObject?.tab)
              ? 'overview'
              : queryObject?.tab?.toString()
          }
        >
          {TABS.map(({ component: Component, ...tab }) => (
            <Tabs.TabPane
              key={tab.value}
              tabKey={tab.value}
              tab={
                <span
                  className={clsx(
                    'font-semibold text-secondary_text',
                    tab.value === queryObject?.tab?.toString() && 'text-black'
                  )}
                  onClick={() => onTabClick(tab.value)}
                >
                  {tab.label}
                </span>
              }
            >
              <div className="my-4">
                <Component />
              </div>
            </Tabs.TabPane>
          ))}
        </Tabs>
      </div>
    </div>
  )
}

export default SaleAnalytics
